import React from 'react';
import { ArrowRightIcon, Loader2Icon } from 'lucide-react';
import { useLeadForm } from '../../hooks/useLeadForm';
import { contact, intentOptions } from '../../data/site';
import { email, required } from '../../utils/validation';
import { Button } from '../ui/Button';
import { TextField } from './fields/TextField';
import { SelectField } from './fields/SelectField';
import { TurnstileSlot } from './TurnstileSlot';
import { FormSuccess } from './FormSuccess';
export function HeroLeadForm() {
  const {
    values,
    errors,
    status,
    setField,
    submit
  } = useLeadForm({
    name: '',
    email: '',
    need: ''
  }, {
    name: required('name'),
    email,
    need: value => value ? null : 'Please choose what you need.'
  });
  if (status === 'success') {
    const firstName = values.name.trim().split(' ')[0];
    return <div className="rounded-card border border-white/10 bg-afb-night-2 p-6" data-id="element-80" data-mp="3p8ollo58drs7">
        <FormSuccess tone="dark" title={`Thanks${firstName ? `, ${firstName}` : ''}. Your request is in.`} data-id="element-81" data-mp="3k7r1h60nuno2">
          An engineer will reply within 48 hours. Want to see it in person first?{' '}
          <a href="#demo-tour" className="font-medium text-afb-turquoise underline underline-offset-4" data-id="element-82" data-mp="lgu2w9jgt9if">
            Book a demo tour
          </a>
          .
        </FormSuccess>
      </div>;
  }
  return <form onSubmit={submit} noValidate aria-labelledby="hero-form-title" className="rounded-card border border-white/10 bg-afb-night-2 p-5 md:p-6" data-id="element-83" data-mp="cet252p0w5c0">
      <div className="mb-4 flex flex-col gap-1 md:flex-row md:items-baseline md:justify-between" data-id="element-84" data-mp="2i7wqg93cs7n">
        <h2 id="hero-form-title" className="font-sora text-base font-semibold text-white" data-id="element-85" data-mp="3kw7edahen5si">
          Request a demo / site assessment
        </h2>
        <p className="text-sm text-white/60" data-id="element-86" data-mp="3pv0jaeimloh2">Three fields. No obligation.</p>
      </div>

      <div className="grid gap-4 md:grid-cols-[1fr_1fr_1fr_auto] md:items-start" data-id="element-87" data-mp="3ay1fz2ut4hse">
        <TextField id="hero-name" label="Name" tone="dark" required autoComplete="name" value={values.name} error={errors.name} onChange={value => setField('name', value)} data-id="element-88" data-mp="3fv9oebq5l7gg" />
        <TextField id="hero-email" label="Work email" type="email" tone="dark" required autoComplete="email" value={values.email} error={errors.email} onChange={value => setField('email', value)} data-id="element-89" data-mp="2n1wpybqn2ma9" />
        <SelectField id="hero-need" label="What do you need?" tone="dark" required placeholder="Choose one" options={intentOptions} value={values.need} error={errors.need} onChange={value => setField('need', value)} data-id="element-90" data-mp="3as0jfqa455nj" />
        <Button type="submit" disabled={status === 'submitting'} className="w-full md:mt-[26px] md:w-auto" data-id="element-91" data-mp="1udr57ozl4xaf">
          {status === 'submitting' ? <>
              <Loader2Icon aria-hidden="true" className="h-4 w-4 animate-spin" data-id="element-92" data-mp="4wdh0by4110r" />
              Sending…
            </> : <>
              Request a demo
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-93" data-mp="9tdnup2sa7sx" />
            </>}
        </Button>
      </div>

      <div className="mt-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between" data-id="element-94" data-mp="jl9mc18s7zxo">
        <p className="text-xs leading-relaxed text-white/60" data-id="element-95" data-mp="okcrdlori65n">
          We respond within 48 hours. By submitting, you agree to our{' '}
          <a href={contact.privacyUrl} className="underline underline-offset-2 hover:text-white" data-id="element-96" data-mp="skwqguswbjuf">
            privacy policy
          </a>
          .
        </p>
        <TurnstileSlot tone="dark" compact data-id="element-97" data-mp="12k3yr3krwoao" />
      </div>
      {status === 'error' && <p role="alert" className="mt-3 text-sm text-red-300" data-id="element-98" data-mp="12hrlv4tvh44h">
          Please check the highlighted fields.
        </p>}
    </form>;
}